import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";

import { BackednResponse } from "@shared/lib/types";
import {  IBucket } from "@shared/lib/types/influencer";
import { BucketService } from "../services/bucket.service"
import { BUCKET_LIST_QUERY_KEY } from "../constants";


export function useBucketById(bucketId:string) {
  const { data, isFetching, isError, error } = useQuery<
    BackednResponse<IBucket>
  >({
    queryKey: [...BUCKET_LIST_QUERY_KEY,bucketId],
    queryFn: async () => await BucketService.getbucketById(bucketId),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);
  return {
    bucket:data?.data,
    isError,
    isFetching,
  };
}
